import React from 'react';
import FloatingShapes from "../common/FloatingShapes";

const events = [
  {
    title: "International Camp Directors Course (ICDC)",
    description:
      "A comprehensive training program designed for camp directors from around the world. The course covers best practices in camp management, child safety, program development, and international collaboration. Participants gain valuable skills and certifications to enhance their camp operations.",
  },
  {
    title: "Children's Camps Development 100 International Conference",
    description:
      "An international conference bringing together camp professionals, educators, and child development experts to discuss the future of children's camping. The conference features keynote speakers, workshops, and networking opportunities focused on advancing camp programs worldwide.",
  },
];

const Events = () => {
  return (
    <>
      {/* ───────────────── Hero Section (Dark) ───────────────── */}
      <section className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute -bottom-20 right-1/3 w-[400px] h-[400px] rounded-full bg-primary-400/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="default" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        />

        <div className="relative min-h-[60vh] pt-40 pb-16 sm:pt-48 sm:pb-20 flex items-center">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 w-full">
            {/* Badge */}
            <div className="flex justify-center mb-10 animate-fade-in">
              <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-primary-300 backdrop-blur-sm">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
                Events
              </div>
            </div>

            {/* Heading */}
            <h1 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mb-6 animate-fade-in">
              <span className="bg-gradient-to-r from-primary-400 via-secondary-400 to-primary-300 bg-clip-text text-transparent">
                Events
              </span>
            </h1>
            <p className="text-center text-lg text-slate-400 max-w-2xl mx-auto animate-fade-in">
              Discover our international events and conferences that bring
              together camp professionals from around the world.
            </p>
          </div>
        </div>
      </section>

      {/* ───────────────── Events Cards (Dark) ───────────────── */}
      <section className="relative overflow-hidden bg-primary-800">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="alt" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        />

        <div className="relative py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14 animate-fade-in">
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                Upcoming & Recurring Events
              </h2>
              <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500" />
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              {events.map((event, index) => {
                const accentGradient = [
                  "from-secondary-500 to-secondary-400",
                  "from-warm-500 to-warm-400",
                ][index % 2];
                return (
                  <div
                    key={event.title}
                    className="relative bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-10 hover:bg-white/[0.08] transform hover:-translate-y-2 transition-all duration-300 group animate-slide-up"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div
                      className={`absolute top-0 left-8 right-8 h-px bg-gradient-to-r ${accentGradient} opacity-0 group-hover:opacity-100 transition-opacity`}
                    />
                    <h3 className="text-xl font-bold text-white mb-4">
                      {event.title}
                    </h3>
                    <p className="text-base leading-7 text-slate-400">
                      {event.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Events;
